<template>
  <div class="app-contact">
    <div class="contact-card">
      <!-- Hero Image -->
      <div class="contact-hero">
        <img
          src="@/assets/images/AppShell/contact.jpg"
          :alt="$t('appcontact.title')"
        />
      </div>

      <!-- Content -->
      <div class="contact-content">
        <h1 class="title">{{ $t('appcontact.title') }}</h1>

        <p class="description">
          {{ $t('appcontact.descPrefix') }}
          <strong>{{ $t('appcontact.phone') }}</strong>。<br />
          {{ $t('appcontact.descSuffix') }}
        </p>

        <!-- Form -->
        <div class="form-group description">
          <label>{{ $t('appcontact.subjectLabel') }}</label>
          <input
            type="text"
            v-model="subject"
            placeholder=""
          />
        </div>

        <div class="form-group description">
          <label>{{ $t('appcontact.messageLabel') }}</label>
          <textarea
            v-model="message"
            rows="6"
            placeholder=""
          />
        </div>

        <div class="actions">
          <button class="submit-btn" @click="handleSubmit">
            {{ $t('appcontact.submit') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { supabase } from '@/lib/supabase'

export default {
  name: 'AppContact',
  data() {
    return {
      subject: '',
      message: '',
    }
  },
  methods: {
    async handleSubmit() {
        const subject = (this.subject || '').trim()
        const message = (this.message || '').trim()

        if (!subject || !message) {
            alert(this.$t('appcontact.alertRequired'))
            return
        }

        // 取登入者
        const { data: { user }, error: userError } = await supabase.auth.getUser()
        if (userError || !user) {
            alert('尚未登入，無法送出')
            return
        }

        // 寫入 DB（多存 user_id）
        const { error } = await supabase
            .from('contact_messages')
            .insert([{
            user_id: user.id,
            subject,
            message,
            }])

        if (error) {
            console.error('Supabase insert error:', error)
            alert('送出失敗，請稍後再試')
            return
        }

        // 成功：清空
        this.subject = ''
        this.message = ''
        alert('已送出，我們會盡快與您聯繫')
    },
  },
}
</script>

<style scoped>
.app-contact {
  display: flex;
  justify-content: center;
  padding: 24px;
}

.contact-card {
  width: 100%;
  max-width: 900px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* Hero */
.contact-hero img {
  width: 100%;
  height: 260px;
  object-fit: cover;
  display: block;
}

/* Content */
.contact-content {
  padding: 32px 40px 40px;
}

.title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #000 !important;
}

.description {
  text-align: left;
  color: #000;
  line-height: 1.7;
  margin-bottom: 32px;
}

/* Form */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}

.form-group input,
.form-group textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  resize: none;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #999;
}

/* Actions */
.actions {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.submit-btn {
  background: #000;
  color: #fff;
  border: none;
  padding: 10px 28px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
}

.submit-btn:hover {
  opacity: 0.85;
}
</style>
